import {match} from 'ts-pattern';

import {always} from 'ramda';

import {salesLeaguePeriodSchema, SalesLeaguePeriod} from '@dms/api/sales';

import {Nullish} from 'shared/web';

import {DEFAULT_SALES_LEAGUE_PERIOD} from '../constants/SALES_LEAGUE_PERIODS';

/**
 * The period lives in the URL, so it can be anything a user types. Anything that is
 * not one of the four supported keys falls back to the default rather than reaching
 * the API as an invalid query param.
 */
export function parseSalesLeaguePeriod(value: string | Nullish): SalesLeaguePeriod {
  return match(salesLeaguePeriodSchema.safeParse(value))
    .with({success: true}, (result) => result.data)
    .otherwise(always(DEFAULT_SALES_LEAGUE_PERIOD));
}
